import { DownloadBillOfLadingDialogProps } from '../components/dialogs/DownloadBillOfLadingDialog';
import { DownloadProductionPackageDialogProps } from '../components/dialogs/DownloadProductionPackageDialog';
import { EditScheduleGroupDialogProps } from '../components/dialogs/schedule-groups/EditScheduleGroupDialog';
import { EditScheduleLineGroupDialogProps } from '../components/dialogs/schedule-line-groups/EditScheduleLineGroupDialog';
import { ConfirmRemoveBundleFromTruckloadDialogProps } from '../components/dialogs/truckloads/ConfirmRemoveBundleFromTruckloadDialog';
import { CreateOrAddToTruckloadDialogProps } from '../components/dialogs/truckloads/CreateOrAddToTruckloadDialog';
import { EditTruckloadDialogProps } from '../components/dialogs/truckloads/EditTruckloadDialog';
import { showPopup } from '../store/popupSlice';
import { ThunkActionVoid } from './thunkActions';

export const CREATE_OR_ADD_TO_BUNDLE_QUANTITIES = 'CREATE_OR_ADD_TO_BUNDLE_QUANTITIES';
export const CREATE_OR_ADD_TO_SCHEDULE_GROUP_DIALOG = 'CREATE_OR_ADD_TO_SCHEDULE_GROUP_DIALOG';
export const EDIT_SCHEDULE_GROUP_DIALOG = 'EDIT_SCHEDULE_GROUP_DIALOG';
export const CREATE_OR_ADD_TO_SCHEDULE_LINE_GROUP_DIALOG = 'CREATE_OR_ADD_TO_SCHEDULE_LINE_GROUP_DIALOG';
export const EDIT_SCHEDULE_LINE_GROUP_DIALOG = 'EDIT_SCHEDULE_LINE_GROUP_DIALOG';
export const CREATE_OR_ADD_TO_TRUCKLOAD_DIALOG = 'CREATE_TRUCKLOAD_DIALOG';
export const EDIT_TRUCKLOAD_DIALOG = 'EDIT_TRUCKLOAD_DIALOG';
export const CONFIRM_REMOVE_BUNDLE_FROM_TRUCKLOAD_DIALOG = 'CONFIRM_REMOVE_BUNDLE_FROM_TRUCKLOAD_DIALOG';
export const DOWNLOAD_PRODUCTION_PACKAGE_DIALOG = 'DOWNLOAD_PRODUCTION_ARTIFACTS_DIALOG';
export const DOWNLOAD_BILL_OF_LADING_DIALOG = 'DOWNLOAD_BILL_OF_LADING_DIALOG';

export interface PopupOptionsMap {
  [CREATE_OR_ADD_TO_BUNDLE_QUANTITIES]: undefined;
  [CREATE_OR_ADD_TO_SCHEDULE_GROUP_DIALOG]: undefined;
  [EDIT_SCHEDULE_GROUP_DIALOG]: EditScheduleGroupDialogProps;
  [CREATE_OR_ADD_TO_SCHEDULE_LINE_GROUP_DIALOG]: undefined;
  [EDIT_SCHEDULE_LINE_GROUP_DIALOG]: EditScheduleLineGroupDialogProps;
  [CREATE_OR_ADD_TO_TRUCKLOAD_DIALOG]: CreateOrAddToTruckloadDialogProps;
  [EDIT_TRUCKLOAD_DIALOG]: EditTruckloadDialogProps;
  [CONFIRM_REMOVE_BUNDLE_FROM_TRUCKLOAD_DIALOG]: ConfirmRemoveBundleFromTruckloadDialogProps;
  [DOWNLOAD_PRODUCTION_PACKAGE_DIALOG]: DownloadProductionPackageDialogProps;
  [DOWNLOAD_BILL_OF_LADING_DIALOG]: DownloadBillOfLadingDialogProps;
}

export function showCreateOrAddToScheduleGroupDialog(): ThunkActionVoid {
  return function showCreateOrAddToScheduleGroupDialogThunkAction(dispatch) {
    dispatch(showPopup(CREATE_OR_ADD_TO_SCHEDULE_GROUP_DIALOG));
  };
}

export function showEditScheduleGroupDialog(scheduleGroupGuid: string): ThunkActionVoid {
  return function showEditScheduleGroupDialogThunkAction(dispatch) {
    const editScheduleGroupDialogProps: EditScheduleGroupDialogProps = { scheduleGroupGuid };
    dispatch(showPopup(EDIT_SCHEDULE_GROUP_DIALOG, editScheduleGroupDialogProps));
  };
}

export function showCreateOrAddToScheduleLineGroupDialog(): ThunkActionVoid {
  return function showCreateOrAddToScheduleLineGroupDialogThunkAction(dispatch) {
    dispatch(showPopup(CREATE_OR_ADD_TO_SCHEDULE_LINE_GROUP_DIALOG));
  };
}

export function showEditScheduleLineGroupDialog(scheduleLineGroupGuid: string): ThunkActionVoid {
  return function showEditScheduleLineGroupDialogThunkAction(dispatch) {
    const editScheduleLineGroupDialogProps: EditScheduleLineGroupDialogProps = { scheduleLineGroupGuid };
    dispatch(showPopup(EDIT_SCHEDULE_LINE_GROUP_DIALOG, editScheduleLineGroupDialogProps));
  };
}

export function showCreateTruckloadDialog(bundleGuids: readonly string[]): ThunkActionVoid {
  return function showCreateTruckloadDialogThunkAction(dispatch) {
    const createTruckloadDialogProps: CreateOrAddToTruckloadDialogProps = { bundleGuids };
    dispatch(showPopup(CREATE_OR_ADD_TO_TRUCKLOAD_DIALOG, createTruckloadDialogProps));
  };
}

export function showEditTruckloadDialog(truckloadGuid: string): ThunkActionVoid {
  return function showEditTruckloadDialogThunkAction(dispatch) {
    const editTruckloadDialogProps: EditTruckloadDialogProps = { truckloadGuid };
    dispatch(showPopup(EDIT_TRUCKLOAD_DIALOG, editTruckloadDialogProps));
  };
}

export function showConfirmRemoveBundleFromTruckloadDialog(bundleGuid: string): ThunkActionVoid {
  return function showConfirmRemoveBundleFromTruckloadDialogThunkAction(dispatch) {
    const confirmRemoveBundleFromTruckloadDialogProps: ConfirmRemoveBundleFromTruckloadDialogProps = { bundleGuid };
    dispatch(showPopup(CONFIRM_REMOVE_BUNDLE_FROM_TRUCKLOAD_DIALOG, confirmRemoveBundleFromTruckloadDialogProps));
  };
}

export function showDownloadProductionArtifactsDialog(
  downloadProductionPackageDialogProps: DownloadProductionPackageDialogProps,
): ThunkActionVoid {
  return function showDownloadProductionArtifactsDialogThunkAction(dispatch) {
    dispatch(showPopup(DOWNLOAD_PRODUCTION_PACKAGE_DIALOG, downloadProductionPackageDialogProps));
  };
}

export function showDownloadBillOfLadingDialog(truckloadGuid: string): ThunkActionVoid {
  return function showDownloadBillOfLadingDialogThunkAction(dispatch) {
    const downloadBillOfLadingDialogProps: DownloadBillOfLadingDialogProps = { truckloadGuid };
    dispatch(showPopup(DOWNLOAD_BILL_OF_LADING_DIALOG, downloadBillOfLadingDialogProps));
  };
}
